import * as React from "react";
import PropTypes from "prop-types";

const ZoomButton = ({
  buttonClassNames,
  children,
  handleZoomButtonClick,
  index,
  isZoomModal,
  tabIndex
}) => (
  <button
    type="button"
    data-testid="zoom-button"
    aria-label={isZoomModal ? "Click to zoom out" : "Click to zoom in"}
    className={buttonClassNames}
    onClick={() => {
      handleZoomButtonClick(index);
    }}
    onMouseDown={(e) => e.preventDefault()}
    data-lulu-track={isZoomModal ? `pdp-zoom-close-image${index}` : ""}
    tabIndex={tabIndex}
  >
    {children}
  </button>
);

export default ZoomButton;

ZoomButton.displayName = "ZoomButton";
ZoomButton.propTypes = {
  buttonClassNames: PropTypes.string,
  children: PropTypes.node,
  handleZoomButtonClick: PropTypes.func,
  index: PropTypes.number,
  isZoomModal: PropTypes.bool,
  tabIndex: PropTypes.string
};

ZoomButton.defaultProps = {
  buttonClassNames: "",
  handleZoomButtonClick: () => {},
  index: 0,
  isZoomModal: false,
  tabIndex: "0"
};
